import { useCallback, useEffect, useRef, useState } from 'react';

export const eventTypes = {
  userLogIn: 'agile_user_login',
};

const skipNextUserLogInEventKey = 'skipNextUserLogInEvent';

// Call this function to skip the next user log in event during transition between applications
export const skipNextUserLogInEvent = () => localStorage.setItem(skipNextUserLogInEventKey, 'true');

export default function GtmUserTrack() {
  const pushEvent = useCallback((eventType, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventType,
      params: payload,
    });
  }, []);

  const hasScriptInjected = useRef(false);
  const hasNoScriptInjected = useRef(false);

  useEffect(() => {
    const GTMId = process.env.REACT_APP_GTM_ID;

    if (!GTMId) {
      console.log('process.env.REACT_APP_GTM_ID is undefined');

      return;
    }

    if (!document.getElementById('gtmScript') || hasScriptInjected.current) {
      const script = document.createElement('script');

      script.id = 'gtmScript';
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTMId}');`;
      document.head.prepend(script);
      hasScriptInjected.current = true;
    }

    if (!document.getElementById('gtmNoScript') || hasNoScriptInjected.current) {
      const noScript = document.createElement('noscript');

      noScript.id = 'gtmNoScript';
      noScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTMId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noScript);
      hasNoScriptInjected.current = true;
    }
  }, []);

  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        const userData = sessionStorage.getItem('USER_DATA');

        if (!userData) return null;

        const parsedUserData = JSON.parse(userData);
        const email = parsedUserData?.['User email'];

        if (email) {
          setUserEmail(email);
          clearInterval(interval);
        }
      } catch {
        console.log('USER_DATA is not loaded into the session storage yet');
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const hasEventPushed = useRef(false);

  useEffect(() => {
    if (!userEmail || hasEventPushed.current) return;

    if (localStorage.getItem(skipNextUserLogInEventKey)) {
      localStorage.removeItem(skipNextUserLogInEventKey);
    } else {
      pushEvent(eventTypes.userLogIn, { user_id: userEmail });
    }

    hasEventPushed.current = true;
  }, [userEmail]);

  return null;
}
